import configdata from "../../config.json";
import { plasticStockSliceAction } from "./PlasticStockSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllPlasticStocksItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/plastic-stocks`
    );

    dispatch(appLevelSliceActions.setLoadingState());

    dispatch(
      plasticStockSliceAction.getAllPlasticStocks(res.data.plasticStock)
    );
  };
};
export const createPlasticStockItem = (
  data,
  duplicateData,
  createOrAddMore
) => {
  let newDuplicateData = { ...duplicateData };

  const plasticTypeList = newDuplicateData.plastic_type.map((item) => {
    const value = item.value;
    return value;
  });

  newDuplicateData.plastic_type = plasticTypeList;

  data = { ...data, ...newDuplicateData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());

    let resurl = `${configdata.SERVER_URL}/api/plastic-stocks/store`;

    let resData = await getApi("post", resurl, form);
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          plasticStockSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      plasticStockSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(plasticStockSliceAction.setInitialData());
    dispatch(plasticStockSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllPlasticStocksItems());
  };
};
export const getDataForEdit = (id, qualityList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/plastic-stocks/edit/${id}`
    );

    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.cartonStock[0] };

    const quality = qualityList.find((item) => {
      return item.value === data.quality_id;
    });

    data.quality = {
      value: quality.value,
      label: quality.label,
      type: quality.type,
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    data.discount_type = {
      value: `${data.discount_type}`,
      label: data.discount_type === "flat" ? "Flat" : "%",
      type: "discount_type",
    };

    dispatch(plasticStockSliceAction.getPlasticStockDataEdit(data));
  };
};

export const adjustPlasticStockItem = (data, adjustedData, duplicateData) => {
  const newDuplicateData = { ...duplicateData };
  const plasticTypeList = duplicateData.plastic_type.map((item) => {
    const value = item.value;
    return value;
  });
  newDuplicateData.plastic_type = plasticTypeList;

  data = { ...data, ...newDuplicateData, ...adjustedData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/plastic-stocks/update/${data.id}`,
      form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          plasticStockSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      plasticStockSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(plasticStockSliceAction.setInitialData());
    dispatch(plasticStockSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllPlasticStocksItems());
  };
};

export const deleteCartoonStockItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/plastic-stocks/delete/${id}`
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};

export const getBillListForVendor = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/plastic-stocks/show/${id}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const data = res.data.data.map((item) => {
      return { value: item, label: item, type: "bill_number" };
    });
    if (data.length > 0) {
      dispatch(plasticStockSliceAction.getBillList({ data: data }));
    } else {
      dispatch(plasticStockSliceAction.getBillList({ data: [] }));
    }
  };
};

export const getDataForAfterBill = (billNumber) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/plastic-stocks/edit/${billNumber}`
    );
    dispatch(appLevelSliceActions.setLoadingState());
    const quantities = [];
    const pricePerPlastic = [];
    const type = [];
    let arrayLength = 0;
    res.data.data.forEach((item) => {
      quantities.push(item.quantity);
      pricePerPlastic.push(item.price_per_plastic);
      type.push({
        value: item.name,
        label: item.name,
        type: "plastic_type",
      });
      arrayLength = arrayLength + 1;
    });
    const data = {
      quantity: quantities,
      price_per_plastic: pricePerPlastic,
      plastic_type: type,
      arrayLength: arrayLength,
    };
    const otherDataWithOutArray = {
      id: parseInt(res.data.data[0].type_id),
      purchase_date: res.data.data[0].purchase_date,
      paid_amount: res.data.data[0].paid_amount,
      total_amount: res.data.data[0].total_amount,
    };

    dispatch(
      plasticStockSliceAction.getDataUsingBill({
        data: data,
        editData: otherDataWithOutArray,
      })
    );
  };
};
